var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.625 8.77777V6.55556C15.625 3.48731 13.1067 1 10 1C6.89342 1 4.37501 3.4873 4.37501 6.55556V8.77777M10 13.7778V16M6.40001 21H13.6C15.4902 21 16.4353 21 17.1572 20.6367C17.7924 20.3171 18.3086 19.8071 18.6322 19.18C19 18.467 19 17.5336 19 15.6667V14.1111C19 12.2443 19 11.3108 18.6322 10.5978C18.3086 9.9706 17.7924 9.46067 17.1572 9.14109C16.4353 8.77777 15.4902 8.77777 13.6 8.77777H6.40001C4.50983 8.77777 3.56474 8.77777 2.84279 9.14109C2.20774 9.46067 1.69142 9.9706 1.36786 10.5978C1 11.3108 1 12.2443 1 14.1111V15.6667C1 17.5336 1 18.467 1.36786 19.18C1.69142 19.8071 2.20774 20.3171 2.84279 20.6367C3.56474 21 4.50983 21 6.40001 21Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.9e94255ffcdef7ceb7fdcae56f83875e.svg";
export { ForwardRef as ReactComponent };